import * as maxLength from "ApiMaxLength";
import { HookFormInput } from "components/HookForm/HookFormInput";
import { HookFormTextArea } from "components/HookForm/HookFormTextArea";
import { InlineSpinner } from "components/InlineSpinner";
import { ResourceKeys, useTranslations } from "providers";
import React from "react";

import { useEditBoardConfiguration } from "../useEditBoardConfiguration";

export const EditBoardConfigurationForm: React.FC = () => {
  const { form, isLoading } = useEditBoardConfiguration();
  const { control } = form;
  const i18n = useTranslations();

  if (!control) return null;

  if (isLoading) {
    return <InlineSpinner text={i18n.Loading} />;
  }

  return (
    <>
      <HookFormInput
        name="signatureFirstName"
        control={control}
        label={ResourceKeys.Board_SignatureFirstName}
        maxLength={maxLength.boardSignatureFirstName}
        contextHelp={ResourceKeys.Board_SignatureFirstName_Help}
      />

      <HookFormInput
        name="signatureLastName"
        control={control}
        label={ResourceKeys.Board_SignatureLastName}
        maxLength={maxLength.boardSignatureLastName}
        contextHelp={ResourceKeys.Board_SignatureLastName_Help}
      />

      <HookFormInput
        name="defaultTime"
        control={control}
        label={ResourceKeys.Board_DefaultTime}
        maxLength={maxLength.boardDefaultTime}
        contextHelp={ResourceKeys.Board_DefaultTime_Help}
      />

      <HookFormInput
        name="defaultDuration"
        control={control}
        label={ResourceKeys.Board_DefaultDuration}
        contextHelp={ResourceKeys.Board_DefaultDuration_Help}
      />

      <HookFormInput
        name="defaultLocation"
        control={control}
        label={ResourceKeys.Board_DefaultLocation}
        maxLength={maxLength.boardDefaultLocation}
        contextHelp={ResourceKeys.Board_DefaultLocation_Help}
      />

      <HookFormTextArea
        name="defaultRemarks"
        control={control}
        label={ResourceKeys.Board_DefaultRemarks}
        maxLength={maxLength.boardDefaultRemarks}
        contextHelp={ResourceKeys.Board_DefaultRemarks_Help}
      />
    </>
  );
};
